import React from "react";
import { connect } from "react-redux";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import Login from "./views/Login/Login";
import Policy from "./views/Policy/Policy";
import Dash from "./containers/Dash";
import Company from "./containers/Company";

class App extends React.Component {
  // componentDidUpdate(e) {
  //     if (window.innerWidth < 993 && e.history.action === "PUSH" && document.documentElement.className.indexOf('nav-open') !== -1) {
  //         document.documentElement.classList.toggle('nav-open')
  //     }
  // }

  render() {
    return <HashRouter>{this._handleRouteGroup(this.props.user)}</HashRouter>;
  }

  _handleRouteGroup = (user) => {
    if (!user) {
      return (
        <Switch>
          <Route path="/login" component={Login} key="login_page" />
          <Route path="/policy" component={Policy} key="integrar_policy" />
          <Route render={() => <Redirect to="/login" />} />
        </Switch>
      );
    } else {
      if (user.roleName === "Integrar") {
        return (
          <Switch>
            <Dash />
          </Switch>
        );
      } else {
        return (
          <Switch>
            <Company />
          </Switch>
        );
      }
    }
  };
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default connect(mapStateToProps, null)(App);



// WEBPACK FOOTER //
// ./src/App.jsx